const init = () => {
  const backToTopBtn = document.querySelector('.js-backToTop');

  if (!backToTopBtn) return;

  backToTopBtn.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

export {
  init
}